import(/* webpackMode: "eager" */ "/app/src/app/ai-scans/claude/page.tsx");
